const addresses = {
  havaToken: "0x5F5D95aD138e85C84B2c695081A0b685224f8F66",
};


export default addresses;
